import { render, staticRenderFns } from "./ticket-prices-edit-showstart.vue?vue&type=template&id=54288cfe&scoped=true&"
import script from "./ticket-prices-edit-showstart.vue?vue&type=script&lang=js&"
export * from "./ticket-prices-edit-showstart.vue?vue&type=script&lang=js&"
import style0 from "./ticket-prices-edit-showstart.vue?vue&type=style&index=0&id=54288cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54288cfe",
  null
  
)

export default component.exports